export default {
  main: [
    { name: 'Main', title: 'Главная', roles: ['admin', 'marketer'] },
    { name: 'Services', title: 'Услуги', roles: ['admin', 'marketer'] },
    { name: 'Settings', title: 'Параметры', roles: ['admin', 'marketer'] },
    { name: 'Promos', title: 'Акции', roles: ['admin', 'marketer'] },
    { name: 'AllEvents', title: 'События', roles: ['admin', 'marketer'] },
    {
      name: 'About',
      title: 'О компании',
      roles: ['admin', 'customerDepartment', 'marketer', 'controller']
    },
    {
      name: 'ServiceRequests',
      title: 'Заявки на обслуживание',
      roles: ['admin', 'marketer']
    },
    {
      name: 'Notifications',
      title: 'Уведомления',
      roles: ['admin', 'marketer', 'customerDepartment']
    },
    {
      name: 'AdditionalPages',
      title: 'Дополнительные страницы',
      roles: ['admin', 'marketer']
    },
    {
      name: 'EmitentNews',
      title: 'Информация по эмитентам',
      roles: ['admin', 'depositary']
    },
    {
      name: 'Software',
      title: 'Программное обеспечение',
      roles: ['admin', 'marketer', 'customerDepartment']
    },
    { name: 'Accounts', title: 'Аккаунты', roles: ['admin', 'superadmin'] },
    {
      name: 'EventsRequests',
      title: 'Заявки на мероприятия',
      roles: ['event-manager']
    },
    {
      name: 'Files',
      title: 'Файлы',
      roles: ['admin', 'superadmin', 'marketer']
    },
    { name: 'Partners', title: 'Партнеры', roles: ['admin', 'marketer'] },
    { name: 'BrandHistory', title: 'История', roles: ['admin', 'marketer'] },
    {
      name: 'IndividualInvestment',
      title: 'ИИС',
      roles: ['admin', 'marketer']
    },
    {
      name: 'Loans',
      title: 'Облигационные займы',
      roles: ['admin', 'marketer']
    },
    { name: 'Redirects', title: 'Редиректы', roles: ['admin', 'superadmin'] },
    { name: 'MetaTags', title: 'Метатеги', roles: ['admin', 'superadmin'] },
    {
      name: 'FinancialClubInfo',
      title: 'Финансовый клуб',
      roles: ['admin', 'superadmin', 'marketer']
    },
    { name: 'Underwriting', title: 'Андеррайтинг', roles: ['admin', 'dcm'] },
    { name: 'Test', title: 'Тестирование', roles: ['admin'] },
    { name: 'M2MSchedule', title: 'Расписание M2M', roles: ['admin', 'depositary'] },
    { name: 'Uprid', title: 'УПРИД', roles: ['admin', 'controller', 'documents'] }
  ],
  about: [
    { name: 'Contacts', title: 'Контакты', roles: ['admin', 'marketer'] },
    {
      name: 'DocumentsContainer',
      title: 'Лицензии, документы и раскрытие информации',
      roles: ['admin', 'marketer', 'controller']
    },
    {
      name: 'DataForClients',
      title: 'Полезная информация и софт для клиентов',
      roles: ['admin', 'marketer', 'customerDepartment']
    },
    { name: 'News', title: 'Новости', roles: ['admin', 'marketer'] },
    {
      name: 'AllPublications',
      title: 'От первого лица, публикации',
      roles: ['admin', 'marketer']
    },
    { name: 'Departments', title: 'Сотрудники', roles: ['admin', 'marketer'] }
  ],
  documents: [
    { name: 'License', title: 'Лицензии', roles: ['admin', 'marketer'] },
    { name: 'Documents', title: 'Документы', roles: ['admin', 'controller'] },
    {
      name: 'InformationContainer',
      title: 'Раскрытие информации',
      roles: ['admin', 'controller']
    }
  ],
  events: [
    { name: 'EventsList', title: 'Мероприятия', roles: ['admin', 'marketer'] },
    { name: 'Webinars', title: 'Вебинары', roles: ['admin', 'marketer'] },
    {
      name: 'FinancialClubs',
      title: 'Финансовый клуб',
      roles: ['admin', 'marketer']
    }
  ],
  loans: [
    {
      name: 'BondedLoan',
      title: 'Страница займов',
      roles: ['admin', 'marketer']
    },
    {
      name: 'Investors',
      title: 'Для инвесторов/эмитентов',
      roles: ['admin', 'marketer']
    }
  ],
  webinars: [
    { name: 'Webinars', title: 'Темы', roles: ['admin', 'marketer'] },
    { name: 'Speakers', title: 'Спикеры', roles: ['admin', 'marketer'] },
    { name: 'Reviews', title: 'Отзывы', roles: ['admin', 'marketer'] }
  ],
  information: [
    {
      name: 'Information',
      title: 'Финансовая отчетность',
      roles: ['admin', 'marketer', 'controller']
    },
    {
      name: 'Disclosure',
      title: 'Информация обязательная к раскрытию',
      roles: ['admin', 'marketer', 'controller']
    },
    // { name: 'NormativeActs', title: 'Законодательство. Нормативные акты и документы', roles: ['admin', 'marketer', 'controller'] },
    {
      name: 'Requisites',
      title: 'Реквизиты для зачисления',
      roles: ['admin', 'marketer', 'controller']
    },
    {
      name: 'BankRequirement',
      title:
        'Информация, предусмотренная указанием банка России от 28.12.2015 No3921-У',
      roles: ['admin', 'marketer', 'controller']
    },
    {
      name: 'BrokerInformation',
      title: 'Уведомления от компании',
      roles: ['admin', 'controller', 'controller']
    }
  ],
  subRoutes: [
    { name: 'Service', roles: ['admin', 'marketer'] },
    { name: 'Investor', roles: ['admin', 'marketer'] },
    { name: 'Events', roles: ['admin', 'marketer'] },
    { name: 'Event', roles: ['admin', 'marketer'] },
    { name: 'Department', roles: ['admin', 'marketer'] },
    { name: 'Office', roles: ['admin', 'marketer'] },
    { name: 'Document', roles: ['admin', 'marketer', 'controller'] },
    { name: 'FinancialClub', roles: ['admin', 'marketer'] },
    { name: 'EmitentNewsEditor', roles: ['admin', 'marketer', 'depositary'] },
    { name: 'EmitentNewsCreator', roles: ['admin', 'marketer', 'depositary'] },
    { name: 'NotificationEditor', roles: ['admin', 'marketer'] },
    { name: 'AdditionalPage', roles: ['admin', 'marketer'] },
    { name: 'NewsEditor', roles: ['admin', 'marketer'] },
    { name: 'PublicationEditor', roles: ['admin', 'marketer'] },
    { name: 'PublicationCreator', roles: ['admin', 'marketer'] },
    {
      name: 'BrokerInformationCreator',
      roles: ['admin', 'marketer', 'controller']
    },
    {
      name: 'BrokerInformationEditor',
      roles: ['admin', 'marketer', 'controller']
    },
    { name: 'NewsCreator', roles: ['admin', 'marketer'] },
    { name: 'PartnerEditor', roles: ['admin', 'marketer'] },
    { name: 'BrandAchievements', roles: ['admin', 'marketer'] },
    { name: 'BrandRecommendations', roles: ['admin', 'marketer'] },
    { name: 'BrandReviews', roles: ['admin', 'marketer'] },
    { name: 'BrandReviewCreator', roles: ['admin', 'marketer'] },
    { name: 'BrandAchievementCreator', roles: ['admin', 'marketer'] },
    { name: 'RecommendationLetterCreator', roles: ['admin', 'marketer'] },
    { name: 'BrokerageHouseCreator', roles: ['admin', 'marketer'] }
  ]
}



// WEBPACK FOOTER //
// ./src/store/accessLevel.js